import React, { useState } from "react";
import { Link } from "react-router-dom";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Sidebar from "./Siderbar";
import Topbar from "./Topbar";
import Footer from "./Footer";
import Dashboard from "./Dashboard";
const AdminPanel = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="d-flex" style={{width:'20%'}}>
      {/* Sidebar */}
      <div
        className={`d-flex flex-column flex-shrink-0 p-3 bg-dark text-white ${
          isSidebarOpen ? "w-100" : "w-0"
        }`}
        style={{
          transition: "width 0.3s",
          overflow: isSidebarOpen ? "visible" : "hidden",
          height: "100%",
        }}
      >
        {isSidebarOpen && (
          <>
            <h2 className="text-white">Admin Panel</h2>
            <hr />
            <ul className="nav nav-pills flex-column mb-auto">
              {/* <li className="nav-item">
                <a href="/" className="nav-link text-white">
                  Dashboard
                </a>
              </li> */}
              <li>
                <Link to="/fetch_admin_product" className="nav-link text-white">
                   Product
                </Link>
              </li>
              <li>
                <Link to="/add-inndus-product" className="nav-link text-white">
                  Add Product
                </Link>
              </li>
              <li>
                <a href="/add-inndus-design" className="nav-link text-white">
                  Add Design
                </a>
              </li>
              <li>
                <a href="#orders" className="nav-link text-white">
                  Orders
                </a>
              </li>
              <li>
                <a href="#settings" className="nav-link text-white">
                  Settings
                </a>
              </li>
            </ul>
            <hr />
            <div className="dropdown">
              <a
                href="#"
                className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
                id="dropdownUser"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="https://via.placeholder.com/32"
                  alt="Admin"
                  className="rounded-circle me-2"
                />
                <strong>Admin</strong>
              </a>
              <ul
                className="dropdown-menu dropdown-menu-dark text-small shadow"
                aria-labelledby="dropdownUser"
              >
                <li>
                  <a className="dropdown-item" href="#profile">
                    Profile
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#settings">
                    Settings
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a className="dropdown-item" href="#logout">
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>

     
    </div>
  );
};

export default AdminPanel;
